module.exports = __webpack_public_path__ + "static/media/IATO-award-photo-2019.ee130f0f.jpg";